import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const MobileNavigation = ({ userType }) => {
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (!isMobile) return null;

  const consumerTabs = [
    { path: '/', icon: '🏠', label: 'Dashboard' },
    { path: '/sites', icon: '📍', label: 'Sites' },
    { path: '/profile', icon: '👤', label: 'Profile' },
  ];

  const operatorTabs = [
    { path: '/', icon: '📊', label: 'Dashboard' },
    { path: '/profile', icon: '👤', label: 'Profile' },
  ];

  const tabs = userType === 'operator' ? operatorTabs : consumerTabs;

  const isTabActive = (tabPath) => {
    if (tabPath === '/') return location.pathname === '/';
    return location.pathname.startsWith(tabPath);
  };

  return (
    <nav className="mobile-bottom-nav">
      {tabs.map(tab => (
        <Link
          key={tab.path}
          to={tab.path}
          className={`nav-tab ${isTabActive(tab.path) ? 'active' : ''}`}
        >
          <span className="nav-icon">{tab.icon}</span>
          <span className="nav-label">{tab.label}</span>
        </Link>
      ))}
    </nav>
  );
};

export default MobileNavigation;
